import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=703773f6"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=703773f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports